import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    redirect: '/jobs'
  },
  {
    path: '/jobs',
    name: 'jobs',
    component: () => import(/*webpackChunckName: "filter" */ '../views/Jobs.vue')
  },
    {
    path: '/edit/:jobId',
    name: 'edit',
    component: () => import(/*webpackChunckName: "filter" */ '../views/EditJob.vue'),
    props: true
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

  const token =  to.query.auth_token || to.query.token || to.query.t
  if (token) {
      localStorage.setItem('auth_token', token)
  }
  next()
})

export default router
